import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Spinner } from "react-bootstrap";
import { useTranslate } from "../../context/TranslationContext";
import Button from "../button";
import "./style.css";

const SwitchToBothRoleModal = ({
  show,
  close,
  onConfirm,
  isLoading,
  title,
  subtitle,
  paragraph1,
  paragraph2,
  roleText,
  yesText,
  cancelText,
}) => {
  const { t } = useTranslate("checkout");
  return (
    <Modal
      show={show}
      centered
      onHide={close}
      className="switch-role-modal"
      dialogClassName="switch-role-modal-dialog"
    >
      <Modal.Header className="switch-role-modal-header border-0 p-0">
        <button
          type="button"
          className="switch-role-modal-close"
          aria-label="Close"
          onClick={close}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </Modal.Header>
      <Modal.Body className="switch-role-modal-body text-center">
        <h4 className="switch-role-modal-heading">
          {title || t("switchRoleModal.title")}
        </h4>
        <p className="switch-role-modal-text">
          {subtitle || t("switchRoleModal.subtitle")}
        </p>
        <p className="switch-role-modal-text">
          {paragraph1 || t("switchRoleModal.paragraph1")}
        </p>
        <p className="switch-role-modal-text mb-4">
          {paragraph2 || t("switchRoleModal.paragraph2")}{" "}
          <strong>{roleText || t("switchRoleModal.role")}</strong>?
        </p>

        <div className="switch-role-modal-actions d-flex justify-content-center gap-3 mt-3">
          <Button
            text={
              isLoading ? (
                <Spinner size="sm" style={{ color: "#fff" }} />
              ) : (
                yesText || t("switchRoleModal.yesBtn")
              )
            }
            className="primaryButton"
            onClick={onConfirm}
            disabled={isLoading}
          />
          <Button
            text={cancelText || t("switchRoleModal.cancelBtn")}
            className="secondaryButton"
            onClick={close}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SwitchToBothRoleModal;
